import { ElementType, FC } from 'react'

import classnames from 'classnames'

import { AppPage } from './styles'

export const Page: FC<{
  as?: ElementType
  noHorizontalPadding?: boolean
  mobilePadding?: boolean
  constrain?: boolean
  playerPadding?: boolean
}> = ({
  children,
  as,
  constrain = false,
  mobilePadding = false,
  noHorizontalPadding = false,
  playerPadding = false,
  ...rest
}) => (
  <AppPage
    as={as}
    className={classnames({
      noHorizontalPadding,
      constrain,
      mobilePadding,
      playerPadding,
    })}
    {...rest}
  >
    {children}
  </AppPage>
)
